export default __webpack_public_path__ + "static/media/menu-food.5057c41d.jpg";